import { Component, OnInit } from "@angular/core";
import { FlatpickrOptions } from "ng2-flatpickr";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { GroupsService } from "../../../../../auth/service/group.service";
import { Router } from "@angular/router";
import moment from "moment";
import Italian from "flatpickr/dist/l10n/it";
import { DocumentsService } from "../../../../../auth/service/documents.service";
import { CollaboratorsService } from "../../../../../modules/collaborators/collaborators.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-documents-send",
  templateUrl: "./documents-send.component.html",
  styleUrls: ["./documents-send.component.scss"],
})
export class DocumentsSendComponent implements OnInit {
  public basicDateOptions: FlatpickrOptions;

  public me: ICurrentUser;

  public contentHeader: IContentHeader;

  public formGroup: FormGroup;

  public showErrors: boolean = false;

  public showEditor: boolean = false;

  public sendToEveryone: boolean = false;

  public requireSignature: boolean = false;

  public requireAcception: boolean = false;

  public sendNow: boolean = false;

  public users_list: any = [];

  public group_list: any = [];

  public categoriesList: any = [];

  private filedocument: any;

  public timeToProcess: any = "";

  public approximateTimeProcess: any;

  public fileName: string = null;

  constructor(
    public _documentService: DocumentsService,
    private _formBuilder: FormBuilder,
    public _userService: UserService,
    public _utilService: UtilsService,
    public _groupService: GroupsService,
    public router: Router,
    public _authenticationService: AuthenticationService,
    private _collaboratorService: CollaboratorsService,
  ) {
    this.formGroup = this._formBuilder.group({
      title: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      category: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      send_date: new FormControl(moment().format("YYYY-MM-DD HH:mm"), [Validators.required]),
      end_date: new FormControl(moment().format("YYYY-MM-DD"), [Validators.required]),
      send_to_users: new FormControl([]),
      send_to_groups: new FormControl(""),
      description: new FormControl("", [Validators.required, Validators.minLength(2)]),
      text: new FormControl(""),
      file: new FormControl(""),
      time: {
        hour: moment().hour(),
        minute: moment().minute(),
      },
    });

    this.basicDateOptions = {
      altFormat: "d/m/Y",
      defaultDate: moment().format("YYYY-MM-DD HH:mm"),
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
      disableMobile: true,
    };

    this.contentHeader = {
      headerTitle: "MENU.DOCUMENTS_SEND",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.DOCUMENTS_LIST",
            isLink: true,
            link: "/dashboard/documents-list",
          },
          {
            name: "MENU.DOCUMENTS_SEND",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.me = await this._authenticationService.getCurrentUser();
    this.categoriesList = await this._documentService.getCategoriesList().then((categories: any) => {
      const orderedListCategories: any = [];
      categories.map((cat: any) => {
        // push del padre
        orderedListCategories.push(cat);
        if (cat.child) {
          cat.child.map((child: any) => {
            orderedListCategories.push(child);
          });
        }
      });
      return orderedListCategories;
    });
    this.users_list = await this._userService.getList("employee", null, true);
    const collaborators: any = await this._collaboratorService.getCollaboratorList();
    this.users_list = [...this.users_list, ...collaborators];
    this.group_list = await this._groupService.getList();
  }

  requireAlsoAcception() {
    if (this.requireSignature) {
      this.requireAcception = false;
    } else {
      this.requireAcception = true;
    }
  }

  changeDestination(send_to: string) {
    if (send_to === "users") {
      this.formGroup.patchValue({ send_to_groups: null });
      this.formGroup.get("send_to_groups").setValidators([]);
    }
    if (send_to === "all") {
      this.formGroup.patchValue({ send_to_users: null });
      this.formGroup.get("send_to_users").setValidators([]);
      this.formGroup.patchValue({ send_to_groups: null });
      this.formGroup.get("send_to_groups").setValidators([]);
    }
    if (send_to === "groups") {
      this.formGroup.patchValue({ send_to_users: null });
      this.formGroup.get("send_to_users").setValidators([]);
    }
  }

  handlerChangeData(event: any) {
    this.formGroup.patchValue({ send_date: event.target.value });
  }

  handlerChangeDataExpire(event: any) {
    this.formGroup.patchValue({ end_date: event.target.value });
  }

  async handlerChangeFileInput(event: any) {
    this.fileName = event.target.files[0].name;
    await this._utilService.convertFileToBase64(event, (e: any) => {
      this.filedocument = e.target.result;
    });
  }

  timeToProcessFiles() {
    if (this.showEditor) {
      this.formGroup?.controls.text.setValidators([Validators.required, Validators.minLength(2)]);
      this.formGroup?.controls.file.setValidators([]);
    } else {
      this.formGroup?.controls.text.setValidators([]);
      this.formGroup?.controls.file.setValidators([Validators.required]);
    }
    this.formGroup?.controls.text.updateValueAndValidity();
    this.formGroup?.controls.file.updateValueAndValidity();

    if (!this.showEditor && !this.sendToEveryone) {
      this.timeToProcess = null;
      return false;
    }
    if ((this.formGroup.value.send_date && moment(this.formGroup.value.send_date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) || this.sendNow === true) {
      let timeToProcess: any = moment(this.formGroup.value.send_date.split(" ")[0] + " " + this.formGroup.value.time.hour + ":" + String(this.formGroup.value.time.minute).padStart(2, "0") + ":00");
      if (this.sendNow) {
        timeToProcess = moment(this.formGroup.value.send_date.split(" ")[0] + " " + moment().format("HH") + ":" + moment().format("mm") + ":00");
      }
      if (this.formGroup.value.send_to_groups && this.formGroup.value.send_to_groups.length > 0) {
        timeToProcess.add(this.formGroup.value.send_to_groups.length * 60, "minutes");
        this.approximateTimeProcess = this.formGroup.value.send_to_groups.length * 60;
      }

      if (this.formGroup.value.send_to_users && this.formGroup.value.send_to_users.length > 0) {
        timeToProcess.add(this.formGroup.value.send_to_users.length, "minutes");
        this.approximateTimeProcess = this.formGroup.value.send_to_users.length;
      }
      if (this.sendToEveryone) {
        timeToProcess.add(this.users_list.length, "minutes");
        this.approximateTimeProcess = this.users_list.length;
      }
      this.timeToProcess = timeToProcess;
    } else {
      this.approximateTimeProcess = null;
      this.timeToProcess = null;
    }
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup?.controls[field_name]?.status === "INVALID";
    } else {
      return this.formGroup?.controls[field_name]?.status === "INVALID" && this.formGroup?.controls[field_name]?.touched;
    }
  }

  async sendDocument() {
    if (!this._authenticationService.hasCapability("create_document")) {
      window.history.back();
      return false;
    }

    this.timeToProcessFiles();
    // if (!this.formGroup.value.title || !this.formGroup.value.category || !this.formGroup.value.send_date) {
    //     await this._utilService.showSWALError({text: 'ERROR_EMPTY_FIELDS'})
    //     return false
    // }
    // if (!this.formGroup.value.description && this.formGroup.value.description.length < 1) {
    //     await this._utilService.showSWALError({text: 'ERROR_EMPTY_FIELDS'})
    //     return false
    // }
    // if (this.showEditor) {
    //     if (!this.formGroup.value.text) {
    //         await this._utilService.showSWALError({text: 'ERROR_INSERT_TEXT'})
    //         return false
    //     }
    // } else {
    //     if (!this.formGroup.value.file && this.formGroup.value.file.length < 1) {
    //         await this._utilService.showSWALError({text: 'ERROR_INSERT_FILE'})
    //         return false
    //     }
    // }

    // controllo se è stato inserito almeno un dipendente o un gruppo
    // if((!this.formGroup.value.send_to_groups && (this.formGroup.value.send_to_users && this.formGroup.value.send_to_users.length < 1) && this.formGroup.value.send_to_groups.length < 1) || (this.formGroup.value.send_to_users == null && this.formGroup.value.send_to_groups.length < 1)) {
    //     await this._utilService.showSWALError({text: 'ERROR_INSERT_USER'})
    //     return false
    // }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      if (
        (!this.formGroup?.value?.send_to_groups && this.formGroup?.value?.send_to_users && this.formGroup?.value?.send_to_users?.length < 1 && this.formGroup?.value?.send_to_groups?.length < 1) ||
        (this.formGroup?.value?.send_to_users == null && this.formGroup?.value?.send_to_groups?.length < 1)
      ) {
        await this._utilService.showSWALError({ text: "ERROR_INSERT_USER" });
        return false;
      }
      return false;
    }

    const day: any = moment(this.formGroup.value.send_date);
    const expireDate: any = moment(this.formGroup.value.end_date);
    day.set("hour", this.formGroup.value.time.hour);
    day.set("minute", this.formGroup.value.time.minute);

    let data = {
      title: this.formGroup.value.title,
      category: this.formGroup.value.category,
      send_date: moment(day).format("YYYY-MM-DD HH:mm:00"),
      send_to_users: this.formGroup.value.send_to_users || [],
      send_to_groups: this.formGroup.value.send_to_groups || [],
      description: this.formGroup.value.description,
      require_signature: this.requireSignature ? 1 : 0,
      require_acception: this.requireAcception ? 1 : 0,
      end_date: null,
    };

    if (this.sendToEveryone) {
      data.send_to_users = this.users_list.map((user) => user.hash);
    }
    if (this.requireSignature || this.requireAcception) {
      data.end_date = moment(expireDate).format("YYYY-MM-DD");
      if (data.end_date === moment().format("YYYY-MM-DD")) {
        await this._utilService.showSWALError({ text: "EXPIRE_DATE_MINIMUM" });
        return false;
      }
      if (data.end_date < data.send_date) {
        await this._utilService.showSWALError({ text: "EXPIRE_DATE_GREATER_THAN_SEND_DATE" });
        return false;
      }
    }

    const today = moment().format("YYYY-MM-DD HH:mm:00");
    if (!this.sendNow && data.send_date < today) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
      return false;
    }

    if (this.sendNow) {
      data.send_date = moment().format("YYYY-MM-DD HH:mm:00");
    }
    const timeToProcess = this.timeToProcess;
    if (timeToProcess) {
      data.send_date = timeToProcess.format("YYYY-MM-DD HH:mm:00");
      let modalText: string = await this._utilService.translate("ALERT.CONFIRM_PROCESS_TIME_TEXT");
      modalText += timeToProcess.format("HH:mm");
      modalText += await this._utilService.translate("ALERT.OF_THE");
      modalText += timeToProcess.format("DD MMMM");
      let stopSend = false;
      await this._utilService
        .showSWALDeleteConfirmation({
          title: "CONFIRM_DELETE_TITLE",
          text: modalText,
          icon: "warning",
          confirmButtonText: "CONFIRM_BTN",
          customClass: {
            confirmButton: "btn btn-success",
          },
        })
        .then(async (result) => {
          if (result.isDismissed) {
            stopSend = true;
          }
        });
      if (stopSend) {
        return false;
      }
    }
    this._utilService.showLoading();
    await this._documentService
      .create(data)
      .then(async (response: any) => {
        this._utilService.hideLoading();
        if (!this.showEditor) {
          await this._documentService
            .upload_file_document(this.filedocument, response.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILE_DOCUMENT" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._documentService.delete(response.id);
              await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE_DOCUMENT" });
              return false;
            });
        } else {
          await this._documentService
            .createFile({ content: this.formGroup.value.text }, response.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_FILE_DOCUMENT" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._documentService.delete(response.id);
              await this._utilService.showSWALError({ text: "ERROR_CREATE_FILE_DOCUMENT" });
              return false;
            });
        }
        this._utilService.hideLoading();
        await this.router.navigateByUrl("dashboard/documents-list");
      })
      .catch(async () => {
        await this._utilService.hideLoading;
        await this._utilService.showSWALError({ text: "ERROR_SEND_DOCUMENT" });
      });
    await this._utilService.hideLoading();
  }

  async setLocalStorage() {
    let text = this.formGroup.value.text;
    if (this._documentService.fieldList && this._documentService.fieldList.length > 0 && this.formGroup.value.send_to_users && this.formGroup.value.send_to_users.length > 0) {
      const profileUser = await this._userService.get(this.formGroup.value.send_to_users[0]);
      if (profileUser) {
        this._documentService.fieldList.map((item: { translate: string; label: string }) => {
          if (item.label === "ADDRESS_CITY" || item.label === "ADDRESS_PROVINCE" || item.label === "ADDRESS_ZIPCODE") {
            text = text.replace(item.label, profileUser?.addresses?.residenza[item.label.toLowerCase().replace("address_", "")]);
          }
          if (item.label.includes("CONTRACT")) {
            text = text.replace(item.label, profileUser?.contract[item.label.toLowerCase().replace("contract_", "")]);
          }
          if (item.label.includes("EDUCATION")) {
            if (profileUser.educations && profileUser.educations.length > 0) {
              if (item.label === "USER_EDUCATION_TITLE") {
                text = text.replace("USER_EDUCATION_TITLE", profileUser.educations[0].title_name, "");
              }
              if (item.label === "USER_EDUCATION_SUBJECT") {
                if (profileUser.educations[0].graduate_name) {
                  text = text.replace("USER_EDUCATION_SUBJECT", profileUser.educations[0].graduate_name);
                } else {
                  text = text.replace("USER_EDUCATION_SUBJECT", profileUser.educations[0].subject);
                }
              }
              if (item.label === "USER_EDUCATION_VOTE") {
                text = text.replace("USER_EDUCATION_VOTE", profileUser.educations[0].vote);
              }
            }
          }
          if (item.label === "ADDRESS_COMPLETE") {
            text = text.replace(
              item.label,
              `${profileUser?.addresses?.residenza?.street} ${profileUser?.addresses?.residenza?.city} ${profileUser?.addresses?.residenza?.zipcode} ${profileUser?.addresses?.residenza?.province}`,
            );
          }
          if (item.label === "USER_IBAN") {
            text = text.replace(item.label, profileUser[item.label.replace("USER_", "")]);
          } else {
            text = text.replace(item.label, profileUser[item.label.toLowerCase().replace("user_", "")]);
          }
          text = text.replace("undefined", "N.D");
          text = text.replace("null", "N.D");
        });
        localStorage.setItem("textEditor", JSON.stringify(text));
        this.router.navigateByUrl("/dashboard/documents-preview");
      } else {
        localStorage.setItem("textEditor", JSON.stringify(text));
        this.router.navigateByUrl("/dashboard/documents-preview");
      }
    } else {
      //ERROR SELECT USER
      await this._utilService.showSWALError({ text: "SELECT_EMPLOYEE" });
    }
  }
}
